var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon2",
    transform: "translate(-929 -818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1113",
    "data-name": "\\uD0C0\\uC6D0 1113",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(929 818)",
    fill: "#eaf8fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speed",
    transform: "translate(940.266 829.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33842",
    "data-name": "\\uD328\\uC2A4 33842",
    d: "M19.734,0A19.734,19.734,0,1,0,39.468,19.734,19.734,19.734,0,0,0,19.734,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33843",
    "data-name": "\\uD328\\uC2A4 33843",
    d: "M54.012,27.014l.563.564L39.7,40.82l-1.69-1.69Z",
    transform: "translate(-23.006 -16.352)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33844",
    "data-name": "\\uD328\\uC2A4 33844",
    d: "M46.472,77v2.368H44.1V77h-.789v2.368H40.947V77h-.789v2.368H37.789V77H37v3.157H47.262V77Z",
    transform: "translate(-22.397 -46.609)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33845",
    "data-name": "\\uD328\\uC2A4 33845",
    d: "M26,8.04a16.633,16.633,0,0,0-13.712,9.249l2.141,1.048A14.283,14.283,0,0,1,26.8,10.378c.126,0,.251,0,.377,0V8c-.388,0-.778.008-1.172.036Z",
    transform: "translate(-7.439 -4.845)",
    fill: "#efc75e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33846",
    "data-name": "\\uD328\\uC2A4 33846",
    d: "M83.492,38.184a14.53,14.53,0,0,1-1.455,6.161,1.2,1.2,0,0,0,.487,1.569l.021.012a1.22,1.22,0,0,0,1.7-.545,16.89,16.89,0,0,0,1.621-7.2,16.488,16.488,0,0,0-1.9-7.7l-2.1,1.1A14.131,14.131,0,0,1,83.492,38.184Z",
    transform: "translate(-49.555 -18.455)",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33847",
    "data-name": "\\uD328\\uC2A4 33847",
    d: "M11.317,45.931l.021-.011a1.159,1.159,0,0,0,.487-1.534,14.53,14.53,0,0,1-1.444-6.751,14,14,0,0,1,1.63-6.036L9.9,30.49a16.345,16.345,0,0,0-1.845,6.326A16.793,16.793,0,0,0,9.618,45.4,1.233,1.233,0,0,0,11.317,45.931Z",
    transform: "translate(-4.842 -18.456)",
    fill: "#3db39e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33848",
    "data-name": "\\uD328\\uC2A4 33848",
    d: "M50,8v2.374a14.2,14.2,0,0,1,12.749,7.931l2.128-1.047A16.574,16.574,0,0,0,50,8Z",
    transform: "translate(-30.266 -4.845)",
    fill: "#f4b459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33849",
    "data-name": "\\uD328\\uC2A4 33849",
    d: "M53.222,22.014l.563.564L39.7,37.793l-1.69-1.69Z",
    transform: "translate(-23.006 -13.325)",
    fill: "#324d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33850",
    "data-name": "\\uD328\\uC2A4 33850",
    d: "M46.973,45a1.973,1.973,0,1,0,1.973,1.973A1.973,1.973,0,0,0,46.973,45Z",
    transform: "translate(-27.239 -27.239)",
    fill: "#1e2d36"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon2);
export default __webpack_public_path__ + "static/media/sec1Icon2.fdff140d16564f1e400d10458bb702dd.svg";
export { ForwardRef as ReactComponent };